
import { defineComponent } from "vue";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  setup() {
    // console.log("hello")
    // const reload = location.reload()
    // const reload = () => {
    //     console.log("test")
    // }
    const router = useRouter();
    const route = useRoute();
    console.log(route.path);
    const pageReload = () => {
      if (route.path === "/") {
        location.reload();
      } else {
        router.push("/");
      }
    };
    return { pageReload };
  },
});
